<template>
  <!-- 我要加入 -->
  <div class="index-container">
    <bannerImg bannerText="我要加入" :isShowTab="true"></bannerImg>
    <personalSidebar>
      <div class="right-content">
        <div class="r-title">消息提醒</div>
        <div class="message-list" v-for="(item, index) in messageList" :key="'msg' + index">
          <div class="icon-box">
            <i
              class="iconfont-icon"
              :class="
                item.title === '系统消息'
                  ? 'icon-shezhi'
                  : item.title === '支付通知'
                  ? 'icon-PCfukuanchenggong'
                  : 'icon-kaoshizuoda'
              "
            ></i>
          </div>
          <div class="right-msg">
            <div class="msg-title">{{ item.title }}</div>
            <div>{{ item.date }}</div>
          </div>
          <i class="iconfont el-icon-arrow-right"></i>
        </div>
      </div>
    </personalSidebar>
  </div>
</template>
<script>
import bannerImg from '../components/bannerImg.vue';
import personalSidebar from '../components/personalSidebar.vue';

export default {
  name: 'message',
  components: {
    bannerImg,
    personalSidebar
  },
  data() {
    return {
      messageList: [
        {
          title: '系统消息',
          date: '04月12日  11:23'
        },
        {
          title: '考试消息',
          date: '04月12日  11:23'
        },
        {
          title: '支付通知',
          date: '04月12日  11:23'
        }
      ]
    };
  },

  mounted() {
    scrollTo(0, 0);
  }
};
</script>
<style lang="scss" scoped>
.index-container {
  padding-bottom: 2PX;
  margin-top: 122PX;
  background-color: #f8f7f6;
}
.right-content {
  width: 72%;
  padding: 32PX 48PX 55PX;
  background-color: #ffffff;
  box-shadow: 0PX 3PX 16PX 0PX rgba(228, 228, 228, 0.35);
  .r-title {
    padding-bottom: 20PX;
    font-size: 20PX;
    font-weight: bold;
    border-bottom: 1PX solid #ececec;
  }
}
.message-list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 26PX 20PX 26PX 0;
  border-bottom: 1PX solid #ececec;
  cursor: pointer;
  &:nth-child(2) {
    .icon-box {
      background-color: #fff6ea;
    }
  }
  &:nth-child(3) {
    .icon-box {
      background-color: #eaf4ff;
    }
  }
  .icon-box {
    width: 54PX;
    height: 54PX;
    margin-right: 15PX;
    line-height: 54PX;
    text-align: center;
    background-color: #eef1ff;
    border-radius: 50%;
  }
  .iconfont-icon {
    font-size: 24PX;
  }
  .icon-shezhi {
    color: #f1a475;
  }
  .icon-kaoshizuoda {
    font-size: 20PX;
    color: #1f45ff;
  }
  .icon-PCfukuanchenggong {
    font-size: 22PX;
    color: #3b9bff;
  }
  .iconfont {
    font-size: 20PX;
    color: #a1a3a6;
  }
  .right-msg {
    flex: 1;
    color: #666666;
  }
  .msg-title {
    padding-bottom: 8PX;
    font-size: 16PX;
    color: #333333;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/message.vue